import Text from "components/base/Text";

import { MotionGrid as Grid } from "utils/motion";

export default function DataBlock({ number, unit, label, inverted, ...props }) {
  return (
    <Grid
      width="100%"
      bg={inverted ? "gray.900" : "gray.200"}
      minHeight={["160px", null, "112px"]}
      px={[2, null, 4]}
      py={[6, null, 12]}
      templateColumns="1fr"
      textAlign="center"
      alignItems={["start", null, "center"]}
      {...props}
    >
      <Grid
        templateColumns="auto auto"
        alignItems="end"
        justifyContent="center"
      >
        <Text
          type="headline_lg"
          textTransform="lowercase"
          letterSpacing={0}
          color={inverted ? "white" : "black.900"}
        >
          {number} {unit}
        </Text>
      </Grid>
      <Text
        gridColumnStart={1}
        gridColumnEnd={3}
        color="gray.400"
        type="title_sm"
        mt="xxs"
      >
        {label}
      </Text>
    </Grid>
  );
}
